import { DefaultState } from 'store/reducers/types';

export const READ_METRO_CLIENTS_DATA_REQUEST = "READ_METRO_CLIENTS_DATA_REQUEST";
export const READ_METRO_CLIENTS_DATA_SUCCESS = "READ_METRO_CLIENTS_DATA_SUCCESS";
export const READ_METRO_CLIENTS_DATA_FAILURE = "READ_METRO_CLIENTS_DATA_FAILURE";

export interface MetroClientsRow {
  filledPercent: string;
  id: number;
  lastJobComment: string;
  leftCand: number;
  leftSlots: number;
  name: string;
  neededCand: number;
  neededFromExternal: string;
  neededSlots: number;
  newSignups: string;
  notCalled: string;
  weight: number;
};

export interface MetroClientsData {
  rows: MetroClientsRow[] | [];
  totalCount: number;
};

export type MetroClientsState = DefaultState & {
  contents?: MetroClientsData;
};

interface ReadMetroClientsDataRequest {
  type: typeof READ_METRO_CLIENTS_DATA_REQUEST;
};

interface ReadMetroClientsDataSuccess {
  type: typeof READ_METRO_CLIENTS_DATA_SUCCESS;
  contents: MetroClientsData;
}

interface ReadMetroClientsDataFailure {
  type: typeof READ_METRO_CLIENTS_DATA_FAILURE;
}

export type ReadMetroClientsActionTypes = ReadMetroClientsDataRequest | ReadMetroClientsDataSuccess | ReadMetroClientsDataFailure;